// import React, { useState, useEffect } from "react";
// import { Menu, X, Plus, Save, Trash2, Pencil, Upload } from "lucide-react";
// import axios from "axios";
// import DashboardSidebar from "../../components/dashboard components/DashboardSidebar";
// import DashboardHeader from "../../components/dashboard components/DashboardHeader";
// import ReactQuill from "react-quill-new";
// import "react-quill-new/dist/quill.snow.css";
// import sanitizeHtml from "sanitize-html";

// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

// const Blogs = () => {
//   const [activeSection, setActiveSection] = useState("blogs");
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [blogs, setBlogs] = useState([]);
//   const [formOpen, setFormOpen] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [editingId, setEditingId] = useState(null);
//   const [formData, setFormData] = useState({
//     blog_name: "",
//     blog_image: "",
//     blog_description: "",
//   });


  


//   const getAuthConfig = () => {
//     const token = localStorage.getItem("token");
//     if (!token) return {};
//     return { headers: { Authorization: `Bearer ${token}` } };
//   };

//   const fetchBlogs = async () => {
//     try {
//       const res = await axios.get(`${API_BASE_URL}/blogs`);
//       setBlogs(res.data);
//     } catch (err) {
//       console.error("Failed to fetch blogs:", err);
//       alert("Unable to load blogs. Please ensure backend is running.");
//     }
//   };

//   useEffect(() => {
//     fetchBlogs();
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const resetForm = () => {
//     setFormData({ blog_name: "", blog_image: "", blog_description: "" });
//     setEditingId(null);
//   };

//   const handleImageUpload = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const uploadData = new FormData();
//     uploadData.append("media", file);

//     try {
//       const config = {
//         ...getAuthConfig(),
//         headers: {
//           ...(getAuthConfig().headers || {}),
//           "Content-Type": "multipart/form-data",
//         },
//       };

//       const res = await axios.post(
//         `${API_BASE_URL}/admin/upload-media`,
//         uploadData,
//         config,
//       );

//       const uploadedUrl = res.data?.data?.files?.[0]?.url;
//       if (uploadedUrl) {
//         setFormData((prev) => ({ ...prev, blog_image: uploadedUrl }));
//       }
//     } catch (err) {
//       console.error("Image upload failed:", err);
//       alert("Image upload failed. Try again.");
//     }
//   };

//   const handleRemoveImage = () => {
//     setFormData((prev) => ({ ...prev, blog_image: "" }));
//   };
  

//   const handleSave = async (e) => {
//     e.preventDefault();

//     if (!formData.blog_name.trim() || !formData.blog_description.trim()) {
//       alert("Please fill in all required fields.");
//       return;
//     }

//     try {
//       setLoading(true);

//       const payload = {
//         blog_id: editingId || 0,
//         ...formData,
//         blog_description: sanitizeHtml(formData.blog_description, {
//           allowedTags: [
//             "p",
//             "strong",
//             "b",
//             "i",
//             "em",
//             "u",
//             "ul",
//             "ol",
//             "li",
//             "br",
//             "h1",
//             "h2",
//             "h3",
//             "blockquote",
//             "a",
//             "img",
//           ],
//           allowedAttributes: {
//             a: ["href", "target"],
//             img: ["src", "alt"],
//           },
//         }),
//       };

//       await axios.post(`${API_BASE_URL}/blogs/save`, payload, getAuthConfig());

//       alert(editingId ? "Blog updated successfully!" : "Blog added successfully!");

//       resetForm();
//       setFormOpen(false);
//       fetchBlogs();
//     } catch (err) {
//       console.error("Error saving blog:", err);
//       alert("Failed to save blog.");
//     } finally {
//       setLoading(false);
//     }
//   };


//   const handleEdit = (blog) => {
//     setEditingId(blog.blog_id);
//     setFormData({
//       blog_name: blog.blog_name || "",
//       blog_image: blog.blog_image || "",
//       blog_description: blog.blog_description || "",
//     });
//     setFormOpen(true);
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm("Are you sure you want to delete this blog?")) return;
//     try {
//       await axios.delete(`${API_BASE_URL}/blogs/${id}`, getAuthConfig());
//       alert("Blog deleted successfully!");
//       fetchBlogs();
//     } catch (err) {
//       console.error("Error deleting blog:", err);
//       alert("Failed to delete blog.");
//     }
//   };

//   return (
//     <div className="flex min-h-screen bg-gray-50 font-sans">
//       {/* Desktop Sidebar */}
//       <div className="hidden lg:block">
//         <DashboardSidebar
//           activeSection={activeSection}
//           setActiveSection={setActiveSection}
//         />
//       </div>

//       {/* Mobile Sidebar */}
//       <div
//         className={`fixed inset-y-0 left-0 bg-white w-72 shadow-2xl transition-transform duration-300 z-50 lg:hidden ${
//           sidebarOpen ? "translate-x-0" : "-translate-x-full"
//         }`}
//       >
//         <DashboardSidebar
//           activeSection={activeSection}
//           setActiveSection={setActiveSection}
//         />
//         <button
//           className="absolute top-4 right-4 text-gray-500 hover:text-blue-600"
//           onClick={() => setSidebarOpen(false)}
//         >
//           <X size={28} />
//         </button>
//       </div>

//       {sidebarOpen && (
//         <div
//           className="fixed inset-0 bg-black bg-opacity-30 z-40 lg:hidden"
//           onClick={() => setSidebarOpen(false)}
//         />
//       )}

//       {/* MAIN CONTENT */}
//       <main className="flex-1 flex flex-col w-full">
//         {/* Header */}
//         <div className="sticky top-0 bg-white z-30 shadow-sm flex items-center justify-between px-4 py-4 sm:px-8">
//           <button
//             className="lg:hidden text-gray-700 hover:text-blue-600"
//             onClick={() => setSidebarOpen(true)}
//           >
//             <Menu size={28} />
//           </button>

//           <div className="flex-1 flex justify-center">
//             <DashboardHeader title="Blog Management" backTo="/dashboard" />
//           </div>
//         </div>

//         {/* Body Content */}
//         <section className="p-4 sm:p-8 w-full max-w-6xl mx-auto bg-white mt-4 rounded-xl shadow-md">
//           {/* Top Row */}
//           <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
//             <h2 className="text-2xl font-bold text-gray-800">Blogs</h2>

//             <button
//               onClick={() => {
//                 if (formOpen) resetForm();
//                 setFormOpen((prev) => !prev);
//               }}
//               className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 sm:px-5 py-2 rounded-lg text-sm sm:text-base"
//             >
//               <Plus size={18} />
//               {formOpen ? "Close Form" : "Add Blog"}
//             </button>
//           </div>

//           {/* Table View */}
//           {!formOpen ? (
//             <div className="overflow-x-auto border border-gray-200 rounded-lg">
//               <table className="min-w-full text-sm">
//                 <thead className="bg-gray-50 text-gray-700">
//                   <tr>
//                     <th className="px-4 py-3 text-left font-semibold">Title</th>
//                     <th className="px-4 py-3 text-left font-semibold">Image</th>
//                     <th className="px-4 py-3 text-center font-semibold">
//                       Actions
//                     </th>
//                   </tr>
//                 </thead>

//                 <tbody>
//                   {blogs.length > 0 ? (
//                     blogs.map((blog) => (
//                       <tr
//                         key={blog.blog_id}
//                         className="border-t hover:bg-gray-50"
//                       >
//                         <td className="px-4 py-3">{blog.blog_name}</td>

//                         <td className="px-4 py-3">
//                           {blog.blog_image ? (
//                             <img
//                               src={blog.blog_image}
//                               alt={blog.blog_name}
//                               className="h-12 w-20 object-cover rounded-md"
//                             />
//                           ) : (
//                             <span className="text-gray-400 italic">
//                               No image
//                             </span>
//                           )}
//                         </td>

//                         <td className="px-4 py-3 text-center">
//                           <div className="flex justify-center gap-4">
//                             <button
//                               onClick={() => handleEdit(blog)}
//                               className="text-blue-600 hover:text-blue-800"
//                             >
//                               <Pencil size={16} />
//                             </button>

//                             <button
//                               onClick={() => handleDelete(blog.blog_id)}
//                               className="text-red-500 hover:text-red-700"
//                             >
//                               <Trash2 size={16} />
//                             </button>
//                           </div>
//                         </td>
//                       </tr>
//                     ))
//                   ) : (
//                     <tr>
//                       <td
//                         colSpan={3}
//                         className="text-center py-5 text-gray-500 italic"
//                       >
//                         No blogs yet.
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             </div>
//           ) : (
//             /* FORM RESPONSIVE LAYOUT */
//             <form onSubmit={handleSave} className="border-t pt-6 space-y-6">
//               <h3 className="text-lg font-semibold text-gray-800">
//                 {editingId ? "Edit Blog" : "Add New Blog"}
//               </h3>

//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                 {/* Title */}
//                 <div className="w-full">
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Blog Title
//                   </label>
//                   <input
//                     name="blog_name"
//                     value={formData.blog_name}
//                     onChange={handleChange}
//                     className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-400 outline-none"
//                     required
//                   />
//                 </div>

//                 {/* Description */}
//                 <div className="col-span-1 md:col-span-2">
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Description
//                   </label>
//                   <ReactQuill
//                     value={formData.blog_description}
//                     onChange={(value) =>
//                       setFormData((prev) => ({
//                         ...prev,
//                         blog_description: value,
//                       }))
//                     }
//                     className="border rounded-lg bg-white"
//                     theme="snow"
//                   />
//                 </div>

//                 {/* Image */}
//                 <div className="col-span-1 md:col-span-2">
//                   <label className="block text-sm font-medium text-gray-700 mb-2">
//                     Blog Image
//                   </label>

//                   {formData.blog_image ? (
//                     <div className="relative w-full max-w-xs sm:max-w-md">
//                       <img
//                         src={formData.blog_image}
//                         alt="Preview"
//                         className="w-full h-48 object-cover rounded-lg border"
//                       />
//                       <button
//                         type="button"
//                         onClick={handleRemoveImage}
//                         className="absolute top-2 right-2 bg-red-500 hover:bg-red-600 text-white p-2 rounded-lg"
//                       >
//                         <X size={16} />
//                       </button>
//                     </div>
//                   ) : (
//                     <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
//                       <input
//                         type="file"
//                         id="blog-image-upload"
//                         accept="image/*"
//                         onChange={handleImageUpload}
//                         className="hidden"
//                       />

//                       <label
//                         htmlFor="blog-image-upload"
//                         className="cursor-pointer flex flex-col items-center gap-2"
//                       >
//                         <Upload size={32} className="text-gray-400" />
//                         <span className="text-gray-700 text-sm">
//                           Click to upload an image
//                         </span>
//                         <span className="text-xs text-gray-600 text-center">
//                           Recommended size: <strong>1200×675 px (16:9)</strong>,
//                           up to 400 KB
//                         </span>
//                       </label>
//                     </div>
//                   )}
//                 </div>
//               </div>

//               <div className="flex justify-end mt-4">
//                 <button
//                   type="submit"
//                   disabled={loading}
//                   className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg"
//                 >
//                   <Save size={18} />
//                   {loading
//                     ? "Saving..."
//                     : editingId
//                       ? "Update Blog"
//                       : "Save Blog"}
//                 </button>
//               </div>
//             </form>
//           )}
//         </section>
//       </main>
//     </div>
//   );
// };

// export default Blogs;


import React, { useState, useEffect } from "react";
import { Menu, X, Plus, Save, Trash2, Pencil, Upload } from "lucide-react";
import axios from "axios";
import DashboardSidebar from "../../components/dashboard components/DashboardSidebar";
import DashboardHeader from "../../components/dashboard components/DashboardHeader";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import sanitizeHtml from "sanitize-html";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

const Blogs = () => {
  const [activeSection, setActiveSection] = useState("blogs");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [blogs, setBlogs] = useState([]);
  const [formOpen, setFormOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editingId, setEditingId] = useState(null);

  const [formData, setFormData] = useState({
    blog_name: "",
    blog_image: "",
    blog_description: "",
  });

  const getAuthConfig = () => {
    const token = localStorage.getItem("token");
    if (!token) return {};
    return { headers: { Authorization: `Bearer ${token}` } };
  };

  const fetchBlogs = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/blogs`);
      setBlogs(res.data);
    } catch (err) {
      console.error("Failed to fetch blogs:", err);
      alert("Unable to load blogs. Please ensure backend is running.");
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const resetForm = () => {
    setFormData({ blog_name: "", blog_image: "", blog_description: "" });
    setEditingId(null);
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const uploadData = new FormData();
    uploadData.append("media", file);

    try {
      const config = {
        ...getAuthConfig(),
        headers: {
          ...(getAuthConfig().headers || {}),
          "Content-Type": "multipart/form-data",
        },
      };

      const res = await axios.post(
        `${API_BASE_URL}/admin/upload-media`,
        uploadData,
        config
      );

      const uploadedUrl = res.data?.data?.files?.[0]?.url;
      if (uploadedUrl) {
        setFormData((prev) => ({ ...prev, blog_image: uploadedUrl }));
      }
    } catch (err) {
      console.error("Image upload failed:", err);
      alert("Image upload failed. Try again.");
    }
  };

  const handleRemoveImage = () => {
    setFormData((prev) => ({ ...prev, blog_image: "" }));
  };

  const handleSave = async (e) => {
    e.preventDefault();

    if (!formData.blog_name.trim() || !formData.blog_description.trim()) {
      alert("Please fill in all required fields.");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        blog_id: editingId || 0,
        ...formData,
        blog_description: sanitizeHtml(formData.blog_description, {
          allowedTags: [
            "p",
            "strong",
            "b",
            "i",
            "em",
            "u",
            "ul",
            "ol",
            "li",
            "br",
            "h1",
            "h2",
            "h3",
            "blockquote",
            "a",
            "img",
            "span",
          ],
          allowedAttributes: {
            a: ["href", "target"],
            img: ["src", "alt"],
            span: ["style"],
          },
        }),
      };

      await axios.post(`${API_BASE_URL}/blogs/save`, payload, getAuthConfig());

      alert(editingId ? "Blog updated successfully!" : "Blog added successfully!");

      resetForm();
      setFormOpen(false);
      fetchBlogs();
    } catch (err) {
      console.error("Error saving blog:", err);
      alert("Failed to save blog.");
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (blog) => {
    setEditingId(blog.blog_id);
    setFormData({
      blog_name: blog.blog_name || "",
      blog_image: blog.blog_image || "",
      blog_description: blog.blog_description || "",
    });
    setFormOpen(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this blog?")) return;

    try {
      await axios.delete(`${API_BASE_URL}/blogs/${id}`, getAuthConfig());
      alert("Blog deleted successfully!");
      fetchBlogs();
    } catch (err) {
      console.error("Error deleting blog:", err);
      alert("Failed to delete blog.");
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-50 font-sans">
      <div className="hidden lg:block">
        <DashboardSidebar
          activeSection={activeSection}
          setActiveSection={setActiveSection}
        />
      </div>

      <div
        className={`fixed inset-y-0 left-0 bg-white w-72 shadow-2xl transition-transform duration-300 z-50 lg:hidden ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <DashboardSidebar
          activeSection={activeSection}
          setActiveSection={setActiveSection}
        />

        <button
          className="absolute top-4 right-4 text-gray-500 hover:text-blue-600"
          onClick={() => setSidebarOpen(false)}
        >
          <X size={28} />
        </button>
      </div>

      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <main className="flex-1 flex flex-col w-full">
        <div className="sticky top-0 bg-white z-30 shadow-sm flex items-center justify-between px-4 py-4 sm:px-8">
          <button
            className="lg:hidden text-gray-700 hover:text-blue-600"
            onClick={() => setSidebarOpen(true)}
          >
            <Menu size={28} />
          </button>

          <div className="flex-1 flex justify-center">
            <DashboardHeader title="Blog Management" backTo="/dashboard" />
          </div>
        </div>

        <section className="p-4 sm:p-8 w-full max-w-6xl mx-auto bg-white mt-4 rounded-xl shadow-md">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
            <h2 className="text-2xl font-bold text-gray-800">Blogs</h2>

            <button
              onClick={() => {
                if (formOpen) resetForm();
                setFormOpen((prev) => !prev);
              }}
              className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 sm:px-5 py-2 rounded-lg text-sm sm:text-base"
            >
              <Plus size={18} />
              {formOpen ? "Close Form" : "Add Blog"}
            </button>
          </div>

          {!formOpen ? (
            <div className="overflow-x-auto border border-gray-200 rounded-lg">
              <table className="min-w-full text-sm">
                <thead className="bg-gray-50 text-gray-700">
                  <tr>
                    <th className="px-4 py-3 text-left font-semibold">Title</th>
                    <th className="px-4 py-3 text-left font-semibold">Image</th>
                    <th className="px-4 py-3 text-center font-semibold">
                      Actions
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {blogs.length > 0 ? (
                    blogs.map((blog) => (
                      <tr
                        key={blog.blog_id}
                        className="border-t hover:bg-gray-50"
                      >
                        <td className="px-4 py-3">{blog.blog_name}</td>

                        <td className="px-4 py-3">
                          {blog.blog_image ? (
                            <img
                              src={blog.blog_image}
                              alt={blog.blog_name}
                              className="h-12 w-20 object-cover rounded-md"
                            />
                          ) : (
                            <span className="text-gray-400 italic">
                              No image
                            </span>
                          )}
                        </td>

                        <td className="px-4 py-3 text-center">
                          <div className="flex justify-center gap-4">
                            <button
                              onClick={() => handleEdit(blog)}
                              className="text-blue-600 hover:text-blue-800"
                              type="button"
                            >
                              <Pencil size={16} />
                            </button>

                            <button
                              onClick={() => handleDelete(blog.blog_id)}
                              className="text-red-500 hover:text-red-700"
                              type="button"
                            >
                              <Trash2 size={16} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={3}
                        className="text-center py-5 text-gray-500 italic"
                      >
                        No blogs yet.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          ) : (
            <form onSubmit={handleSave} className="border-t pt-6 space-y-6">
              <h3 className="text-lg font-semibold text-gray-800">
                {editingId ? "Edit Blog" : "Add New Blog"}
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="w-full">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Blog Title
                  </label>

                  <input
                    name="blog_name"
                    value={formData.blog_name}
                    onChange={handleChange}
                    className="w-full border rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-400 outline-none"
                    required
                  />
                </div>

                <div className="col-span-1 md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Description
                  </label>

                  <div className="border rounded-lg bg-white overflow-hidden">
                    <CKEditor
                      editor={ClassicEditor}
                      data={formData.blog_description}
                      onChange={(event, editor) => {
                        const value = editor.getData();
                        setFormData((prev) => ({
                          ...prev,
                          blog_description: value,
                        }));
                      }}
                    />
                  </div>
                </div>

                <div className="col-span-1 md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Blog Image
                  </label>

                  {formData.blog_image ? (
                    <div className="relative w-full max-w-xs sm:max-w-md">
                      <img
                        src={formData.blog_image}
                        alt="Preview"
                        className="w-full h-48 object-cover rounded-lg border"
                      />

                      <button
                        type="button"
                        onClick={handleRemoveImage}
                        className="absolute top-2 right-2 bg-red-500 hover:bg-red-600 text-white p-2 rounded-lg"
                      >
                        <X size={16} />
                      </button>
                    </div>
                  ) : (
                    <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
                      <input
                        type="file"
                        id="blog-image-upload"
                        accept="image/*"
                        onChange={handleImageUpload}
                        className="hidden"
                      />

                      <label
                        htmlFor="blog-image-upload"
                        className="cursor-pointer flex flex-col items-center gap-2"
                      >
                        <Upload size={32} className="text-gray-400" />
                        <span className="text-gray-700 text-sm">
                          Click to upload an image
                        </span>
                        <span className="text-xs text-gray-600 text-center">
                          Recommended size: <strong>1200×675 px (16:9)</strong>,
                          up to 400 KB
                        </span>
                      </label>
                    </div>
                  )}
                </div>
              </div>

              <div className="flex justify-end mt-4">
                <button
                  type="submit"
                  disabled={loading}
                  className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg"
                >
                  <Save size={18} />
                  {loading
                    ? "Saving..."
                    : editingId
                    ? "Update Blog"
                    : "Save Blog"}
                </button>
              </div>
            </form>
          )}
        </section>
      </main>
    </div>
  );
};

export default Blogs;